import { createBrowserRouter } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { Dashboard } from './pages/Dashboard';
import { PatientsPage } from './pages/Patients/PatientsPage';
import { PatientProfilePage } from './pages/Patients/PatientProfilePage';
import { AddPatientPage } from './pages/Patients/AddPatientPage';
import { AddVisitPage } from './pages/Visits/AddVisitPage';
import { VisitDetailsPage } from './pages/Visits/VisitDetailsPage';
import { VisitImagesPage } from './pages/Visits/VisitImagesPage';
import { PrescriptionBuilderPage } from './pages/Prescriptions/PrescriptionBuilderPage';
import { PrescriptionSettingsPage } from './pages/Prescriptions/PrescriptionSettingsPage';
import { DrugsPage } from './pages/Drugs/DrugsPage';
import { LabTestsPage } from './pages/LabTests/LabTestsPage';
import { RadiologyTestsPage } from './pages/RadiologyTests/RadiologyTestsPage';
import { LoginPage } from './pages/Login';
import { ProtectedRoute } from './components/common/ProtectedRoute';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'patients', element: <PatientsPage /> },
      { path: 'patients/new', element: <AddPatientPage /> },
      { path: 'patients/:id', element: <PatientProfilePage /> },
      { path: 'visits/new', element: <AddVisitPage /> },
      { path: 'visits/:id', element: <VisitDetailsPage /> },
      { path: 'patients/:patientId/visit-images', element: <VisitImagesPage /> },
      { path: 'prescriptions/new', element: <PrescriptionBuilderPage /> },
      { path: 'settings/prescription', element: <PrescriptionSettingsPage /> },
      { path: 'drugs', element: <DrugsPage /> },
      { path: 'lab-tests', element: <LabTestsPage /> },
      { path: 'radiology-tests', element: <RadiologyTestsPage /> },
    ],
  },
]);

